export enum FeatureToggle {
  auditLogs = 'rt_audit_logs_list',
}
